import React from 'react';
import './SpinnerRing.css';

export default function SpinnerRing({ text = 'LOADING • ', repeats = 6, size = 140, color = 'white', fontSize = 12 }) {
  const repeated = (text.repeat(repeats));
  const chars = Array.from(repeated);
  const total = chars.length;
  const centerFont = Math.max(10, Math.min(18, Math.round(size * 0.12)));
  return (
    <div className="spinner-ring" style={{ width: size, height: size, color }}>

      <span className="text-ring" style={{ ['--total']: total }} aria-label="Loading">
        <span aria-hidden="true">
          {chars.map((ch, i) => (
            <span key={i} style={{ ['--index']: i, fontSize }}>{ch}</span>
          ))}
        </span>
        <span className="sr-only">Loading</span>
      </span>

    </div>
  );
}


